/* ==========================================================================
   Cart Drawer — Upsell, Donation & Confetti
   ========================================================================== */

/* ---- Confetti Threshold Detection ---- */
(function () {
  var previousCartTotal = 0;
  var GIFT_THRESHOLD = 10000; // 100 CHF in cents
  var checkTimeout;

  function checkConfetti() {
    var el = document.querySelector('.cart-drawer-progress[data-cart-total]');
    if (!el) return;

    var newTotal = parseInt(el.dataset.cartTotal, 10) || 0;

    if (previousCartTotal > 0 && previousCartTotal < GIFT_THRESHOLD && newTotal >= GIFT_THRESHOLD) {
      fireConfetti();
    }

    previousCartTotal = newTotal;
  }

  function loadConfettiLib() {
    if (typeof confetti !== 'undefined') return Promise.resolve();
    return new Promise(function (resolve) {
      var s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.2/dist/confetti.browser.min.js';
      s.onload = resolve;
      s.onerror = resolve;
      document.head.appendChild(s);
    });
  }

  function fireConfetti() {
    var canvas = document.getElementById('cart-confetti');
    if (!canvas) return;

    loadConfettiLib().then(function () {
      if (typeof confetti === 'undefined') return;

      var myConfetti = confetti.create(canvas, { resize: true, useWorker: true });
      var defaults = { origin: { y: 0.5 } };
      var count = 200;

      function fire(particleRatio, opts) {
        myConfetti(Object.assign({}, defaults, opts, {
          particleCount: Math.floor(count * particleRatio),
        }));
      }

      fire(0.25, { spread: 26, startVelocity: 55, colors: ['#5B7C75', '#C78873'] });
      fire(0.2, { spread: 60, colors: ['#FFF7F0', '#2C3E50'] });
      fire(0.35, { spread: 100, decay: 0.91, scalar: 0.8 });
      fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 });
      fire(0.1, { spread: 120, startVelocity: 45 });
    });
  }

  function init() {
    var el = document.querySelector('.cart-drawer-progress[data-cart-total]');
    if (el) {
      previousCartTotal = parseInt(el.dataset.cartTotal, 10) || 0;
    }

    // Observe cart-drawer for DOM changes (section re-renders)
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      new MutationObserver(function () {
        clearTimeout(checkTimeout);
        checkTimeout = setTimeout(checkConfetti, 150);
      }).observe(cartDrawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---- Upsell Custom Element ---- */
if (!customElements.get('cart-drawer-upsell')) {
  class CartDrawerUpsell extends HTMLElement {
    /** Static cache: survives DOM re-renders */
    static _cache = {};
    static _fetchPromises = {};

    connectedCallback() {
      this.productIds = (this.dataset.productIds || '').split(',').filter(Boolean);
      this.cartVariantIds = (this.dataset.cartVariantIds || '').split(',').filter(Boolean);
      this.moneyFormat = this.dataset.moneyFormat || '{{amount}} CHF';

      if (this.productIds.length === 0) {
        this.innerHTML = '';
        return;
      }

      var seedId = this.productIds[0];

      // Fix 1: serve from static cache if available (no fetch)
      if (CartDrawerUpsell._cache[seedId]) {
        this.renderFromCache(seedId);
        return;
      }

      this.fetchRecommendations();
    }

    renderFromCache(seedId) {
      var self = this;
      var products = (CartDrawerUpsell._cache[seedId] || []).filter(function (p) {
        return !self.cartVariantIds.includes(String(p.variants[0] && p.variants[0].id));
      }).slice(0, 4);

      if (products.length === 0) {
        this.innerHTML = '';
        return;
      }
      this.renderProducts(products);
    }

    async fetchRecommendations() {
      var seedId = this.productIds[0];
      try {
        // Deduplicate in-flight requests for the same seedId
        if (!CartDrawerUpsell._fetchPromises[seedId]) {
          CartDrawerUpsell._fetchPromises[seedId] = fetch(
            (window.routes.product_recommendations_url || '/recommendations/products') +
              '.json?product_id=' + seedId + '&limit=10&intent=complementary'
          ).then(function (res) {
            if (!res.ok) throw new Error('fetch failed');
            return res.json();
          }).then(function (data) {
            var allProducts = data.products || [];
            CartDrawerUpsell._cache[seedId] = allProducts;
            return allProducts;
          }).finally(function () {
            delete CartDrawerUpsell._fetchPromises[seedId];
          });
        }

        var allProducts = await CartDrawerUpsell._fetchPromises[seedId];
        var self = this;
        var products = allProducts.filter(function (p) {
          return !self.cartVariantIds.includes(String(p.variants[0] && p.variants[0].id));
        });
        products = products.slice(0, 4);

        if (products.length === 0) {
          this.innerHTML = '';
          return;
        }

        this.renderProducts(products);
      } catch (e) {
        // Silently fail — upsell is not critical
      }
    }

    formatMoney(cents) {
      // Doit couvrir tous les formats monétaires de la boutique : le format EUR
      // utilise {{amount_with_comma_separator}}, pas {{amount}}.
      var s = (cents / 100).toFixed(2);
      var withComma = s.replace('.', ',');
      var withApostrophe = s.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
      return this.moneyFormat
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withComma.split(',')[0])
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
        .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, withApostrophe)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, s.split('.')[0])
        .replace(/\{\{\s*amount\s*\}\}/g, s);
    }

    renderProducts(products) {
      var self = this;
      var cards = products
        .map(function (p) {
          var variantId = p.variants[0] ? p.variants[0].id : '';
          var urlProduit = p.url || (p.handle ? '/products/' + p.handle : '');
          return '<div class="cart-drawer-upsell__card" data-price="' + (Number(p.price) || 0) + '">' +
            '<a class="cart-drawer-upsell__card-link" href="' + self.escapeHtml(urlProduit) + '">' +
              '<div class="cart-drawer-upsell__card-img">' +
                (p.featured_image
                  ? '<img src="' + p.featured_image + '" alt="' + self.escapeHtml(p.title) + '" loading="lazy" width="96" height="96">'
                  : '') +
              '</div>' +
              '<div class="cart-drawer-upsell__card-info">' +
                '<p class="cart-drawer-upsell__card-title">' + self.escapeHtml(p.title) + '</p>' +
                '<p class="cart-drawer-upsell__card-price">' + self.formatMoney(p.price) + '</p>' +
              '</div>' +
            '</a>' +
            '<button type="button" class="cart-drawer-upsell__add-btn" aria-label="' + self.escapeHtml(((window.ccTraductions || {}).upsellAjouter || 'Ajouter ')) + self.escapeHtml(p.title) + '" data-variant-id="' + variantId + '">' +
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path d="M10 5a.75.75 0 0 1 .75.75v3.5h3.5a.75.75 0 0 1 0 1.5h-3.5v3.5a.75.75 0 0 1-1.5 0v-3.5h-3.5a.75.75 0 0 1 0-1.5h3.5v-3.5A.75.75 0 0 1 10 5z"/></svg>' +
              '<svg class="spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M12 2a10 10 0 0 1 10 10" stroke-linecap="round"/></svg>' +
            '</button>' +
          '</div>';
        })
        .join('');

      this.innerHTML =
        '<h4 class="cart-drawer-upsell__title">' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path d="M10 2a1 1 0 0 1 .894.553l1.618 3.28 3.619.526a1 1 0 0 1 .554 1.706l-2.619 2.553.618 3.603a1 1 0 0 1-1.45 1.054L10 13.347l-3.234 1.7a1 1 0 0 1-1.45-1.054l.618-3.603L3.315 7.837a1 1 0 0 1 .554-1.706l3.619-.526 1.618-3.28A1 1 0 0 1 10 2z"/></svg>' +
          self.escapeHtml((window.ccTraductions || {}).upsellTitre || ' On oublie souvent...') +
        '</h4>' +
        '<div class="cart-drawer-upsell__scroll">' + cards + '</div>';

      this.querySelectorAll('.cart-drawer-upsell__add-btn').forEach(function (btn) {
        btn.addEventListener('click', function (e) { self.handleAdd(e); });
      });

      // Au survol d'une carte (bouton + inclus) : projeter sur la barre l'effet
      // d'un ajout du produit. Délégation sur le conteneur : survit aux
      // re-rendus et ne dépend pas de listeners posés carte par carte.
      if (!this._survolBranche) {
        this._survolBranche = true;
        this.addEventListener('mouseover', function (e) {
          var carte = e.target.closest('.cart-drawer-upsell__card');
          if (carte) self.montrerProjection(Number(carte.dataset.price));
        });
        this.addEventListener('mouseout', function (e) {
          var carte = e.target.closest('.cart-drawer-upsell__card');
          if (!carte) return;
          if (e.relatedTarget && carte.contains(e.relatedTarget)) return;
          self.cacherProjection();
        });
      }

      // Accordéon manuel : chevron statique + titre cliquable pour rouvrir/replier
      // les suggestions quand le panier est scrollé (--replie posé par cart-drawer.js).
      var titre = this.querySelector('.cart-drawer-upsell__title');
      if (titre && !titre.querySelector('.cart-drawer-upsell__chevron')) {
        titre.insertAdjacentHTML(
          'beforeend',
          '<svg class="cart-drawer-upsell__chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.39a.75.75 0 0 1-1.08 0L5.23 8.27a.75.75 0 0 1 .02-1.06z"/></svg>'
        );
        titre.addEventListener('click', function () {
          self.classList.toggle('cart-drawer-upsell--ouvert');
        });
      }
    }

    montrerProjection(prixCents) {
      var progress = this.closest('.cart-drawer-progress');
      if (!progress || !prixCents) return;
      var apercu = progress.querySelector('.cart-drawer-progress__fill-preview');
      if (!apercu) return;
      var total = Number(progress.dataset.cartTotal) || 0;
      var seuilLivraison = Number(progress.dataset.shipThreshold) || 15000;
      var pctActuel = Math.min((total / seuilLivraison) * 100, 100);
      var pctProjete = Math.min(((total + prixCents) / seuilLivraison) * 100, 100);
      if (pctProjete <= pctActuel) return;
      // Pilotage direct du display : l'attribut hidden s'est montré peu fiable
      // dans ce contexte (resté display:none après retrait, cause non identifiée).
      // Départ à largeur nulle puis reflow forcé : la barre « progresse » vers
      // le niveau projeté au lieu d'apparaître d'un bloc.
      if (this._timerRetrait) {
        clearTimeout(this._timerRetrait);
        this._timerRetrait = null;
      }
      apercu.style.left = pctActuel + '%';
      if (apercu.style.display !== 'block') {
        apercu.style.width = '0%';
        apercu.style.display = 'block';
        void apercu.offsetWidth;
      }
      apercu.style.width = (pctProjete - pctActuel) + '%';
    }

    cacherProjection() {
      var progress = this.closest('.cart-drawer-progress');
      var apercu = progress && progress.querySelector('.cart-drawer-progress__fill-preview');
      if (!apercu) return;
      // Rétraction symétrique : la projection se replie vers le niveau actuel,
      // puis disparaît une fois la transition finie (annulée si re-survol).
      var self = this;
      apercu.style.width = '0%';
      if (this._timerRetrait) clearTimeout(this._timerRetrait);
      this._timerRetrait = setTimeout(function () {
        apercu.style.display = 'none';
        self._timerRetrait = null;
      }, 500);
    }

    async handleAdd(e) {
      var btn = e.currentTarget;
      var variantId = btn.dataset.variantId;
      if (!variantId || btn.classList.contains('loading')) return;

      btn.classList.add('loading');

      try {
        var cartDrawer = document.querySelector('cart-drawer');
        var sections = cartDrawer ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; }) : [];

        var body = {
          id: parseInt(variantId, 10),
          quantity: 1,
          sections: sections.join(','),
          sections_url: window.location.pathname,
        };

        var res = await fetch((window.routes.cart_add_url || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });

        if (!res.ok) throw new Error('Add failed');

        var data = await res.json();

        if (cartDrawer && data.sections) {
          cartDrawer.renderContents({ id: data.product_id, sections: data.sections });
        } else {
          window.location.href = window.routes.cart_url || '/cart';
        }
      } catch (err) {
        btn.classList.remove('loading');
      }
    }

    escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }
  }

  customElements.define('cart-drawer-upsell', CartDrawerUpsell);
}

/* ---- Donation Custom Element ---- */
if (!customElements.get('cart-drawer-donation')) {
  class CartDrawerDonation extends HTMLElement {
    /** Cache product data across instances (survives re-renders) */
    static _variantMap = null;
    static _fetchPromise = null;
    /** Fix 2: flag to skip auto-swap after our own renderContents triggers re-mount */
    static _skipAutoSwap = false;

    connectedCallback() {
      this.cartTotal = parseInt(this.dataset.cartTotal, 10) || 0;
      this.donationHandle = this.dataset.donationHandle || 'don-pour-un-refuge';
      this.moneyFormat = this.dataset.moneyFormat || '{{amount}} CHF';
      this.currentVariantInCart = this.dataset.donationVariantInCart || null;
      this.currentLineKey = this.dataset.donationLineKey || null;
      this.checkbox = this.querySelector('.cart-drawer-donation__checkbox');
      this.details = this.querySelector('.cart-drawer-donation__details');
      this.amountEl = this.querySelector('.cart-drawer-donation__amount');
      this.donationValueEl = this.querySelector('.cart-drawer-donation__donation-value');
      this.donationValueEls = this.querySelectorAll('.cart-drawer-donation__donation-value');
      this.summaryEl = this.querySelector('.cart-drawer-donation__summary');
      this._busy = false;

      if (!this.checkbox) return;

      this.computeDonation();
      this.updateUI();

      var self = this;
      this.checkbox.addEventListener('change', function () {
        self.onCheckboxChange();
      });

      // Fix 2: skip auto-swap if we just triggered a renderContents ourselves
      if (CartDrawerDonation._skipAutoSwap) {
        CartDrawerDonation._skipAutoSwap = false;
        return;
      }

      // Auto-swap: if donation is active and the required variant changed (cart total changed)
      if (this.checkbox.checked && this.currentVariantInCart) {
        this.updateTotalOptimistic(true);
        this.setCheckoutLoading(true);
        this.fetchVariantMap().then(function (map) {
          if (!map) { self.setCheckoutLoading(false); return; }
          var neededId = self.getVariantIdForAmount(self.donationAmount);
          if (neededId && String(neededId) !== String(self.currentVariantInCart)) {
            self.swapVariant(neededId);
          } else {
            self.setCheckoutLoading(false);
          }
        });
      } else {
        // Lazy: don't prefetch variant map — will be fetched on first checkbox interaction
      }
    }

    /* ── Product data fetch (cached) ── */

    fetchVariantMap() {
      if (CartDrawerDonation._variantMap) return Promise.resolve(CartDrawerDonation._variantMap);
      if (CartDrawerDonation._fetchPromise) return CartDrawerDonation._fetchPromise;

      CartDrawerDonation._fetchPromise = fetch('/products/' + this.donationHandle + '.json')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var map = {};
          (data.product.variants || []).forEach(function (v) {
            // v.price is a string like "5.70" from the Product JSON API
            var price = parseFloat(v.price).toFixed(2);
            map[price] = v.id;
          });
          CartDrawerDonation._variantMap = map;
          return map;
        })
        .catch(function () {
          CartDrawerDonation._fetchPromise = null;
          return null;
        });

      return CartDrawerDonation._fetchPromise;
    }

    /* ── Money formatting ── */

    formatMoney(amountFloat) {
      var s = amountFloat.toFixed(2);
      var withComma = s.replace('.', ',');
      var withApostrophe = s.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
      return this.moneyFormat
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withComma.split(',')[0])
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
        .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, withApostrophe)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, s.split('.')[0])
        .replace(/\{\{\s*amount\s*\}\}/g, s);
    }

    /* ── Donation math ── */

    computeDonation() {
      var totalCHF = this.cartTotal / 100;
      var nextTen = Math.ceil((totalCHF + 0.01) / 10) * 10;

      this.roundedTotal = nextTen;
      this.donationAmount = +(nextTen - totalCHF).toFixed(2);

      if (this.amountEl) this.amountEl.textContent = this.formatMoney(this.roundedTotal);
      var formatted = this.formatMoney(this.donationAmount);
      if (this.donationValueEls) {
        this.donationValueEls.forEach(function (el) { el.textContent = formatted; });
      } else if (this.donationValueEl) {
        this.donationValueEl.textContent = formatted;
      }
    }

    getVariantIdForAmount(amount) {
      if (!CartDrawerDonation._variantMap) return null;
      var key = amount.toFixed(2);
      return CartDrawerDonation._variantMap[key] || null;
    }

    /* ── UI ── */

    updateUI() {
      var isActive = this.checkbox.checked;

      if (this.details) {
        this.details.classList.toggle('cart-drawer-donation__details--inactive', !isActive);
      }

      if (this.summaryEl) {
        if (isActive) {
          this.summaryEl.textContent = ((window.ccTraductions || {}).donMerci || '\u2764 Merci pour votre don de ') + this.formatMoney(this.donationAmount);
          this.summaryEl.style.display = '';
        } else {
          this.summaryEl.style.display = 'none';
        }
      }
    }

    /* ── Checkbox handler ── */

    async onCheckboxChange() {
      var isActive = this.checkbox.checked;
      this.updateUI();
      this.updateTotalOptimistic(isActive);

      if (this._busy) return;
      this._busy = true;

      this.setCheckoutLoading(true);

      try {
        if (isActive) {
          await this.addDonation();
        } else {
          await this.removeDonation();
        }
      } finally {
        this._busy = false;
        this.setCheckoutLoading(false);
      }
    }

    /** Instantly update the displayed cart total without waiting for the server */
    updateTotalOptimistic(adding) {
      var totalEl = document.querySelector('.totals__total-value');
      if (!totalEl) return;
      var donationCents = Math.round(this.donationAmount * 100);
      var baseCents = this.cartTotal;
      var newCents = adding ? baseCents + donationCents : baseCents;
      totalEl.textContent = this.formatMoney(newCents / 100);
    }

    /* ── Cart operations ── */

    getSectionsToRender() {
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        return cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
      }
      return [];
    }

    async addDonation() {
      var map = await this.fetchVariantMap();
      if (!map) return;

      var variantId = this.getVariantIdForAmount(this.donationAmount);
      if (!variantId) return;

      var sections = this.getSectionsToRender();

      // Fix 3: sequential — saveAttributes first, then cart/add
      await this.saveAttributes(true);

      var res = await fetch((window.routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: sections.join(','),
          sections_url: window.location.pathname,
        }),
      });

      if (!res.ok) return;
      var data = await res.json();

      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && data.sections) {
        CartDrawerDonation._skipAutoSwap = true; // Fix 2: prevent re-mount auto-swap
        cartDrawer.renderContents({ sections: data.sections });
        this.patchCheckbox(true);
      }
    }

    async removeDonation() {
      if (!this.currentLineKey) {
        await this.saveAttributes(false);
        return;
      }

      var sections = this.getSectionsToRender();

      // Fix 3: sequential — saveAttributes first, then cart/change
      await this.saveAttributes(false);

      var res = await fetch((window.routes.cart_change_url || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: this.currentLineKey,
          quantity: 0,
          sections: sections.join(','),
          sections_url: window.location.pathname,
        }),
      });

      if (!res.ok) return;
      var data = await res.json();

      this.currentVariantInCart = null;
      this.currentLineKey = null;

      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && data.sections) {
        CartDrawerDonation._skipAutoSwap = true; // Fix 2: prevent re-mount auto-swap
        cartDrawer.renderContents({ sections: data.sections });
        this.patchCheckbox(false);
      }
    }

    async swapVariant(newVariantId) {
      if (this._busy) return;
      this._busy = true;
      this.setCheckoutLoading(true);

      try {
        // Fix 3: fully sequential — saveAttributes → remove → add
        await this.saveAttributes(true);

        if (this.currentLineKey) {
          await fetch((window.routes.cart_change_url || '/cart/change') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: this.currentLineKey,
              quantity: 0,
            }),
          });
        }

        // Add new variant (with sections for re-render)
        var sections = this.getSectionsToRender();
        var res = await fetch((window.routes.cart_add_url || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: newVariantId,
            quantity: 1,
            sections: sections.join(','),
            sections_url: window.location.pathname,
          }),
        });

        if (!res.ok) return;
        var data = await res.json();

        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && data.sections) {
          CartDrawerDonation._skipAutoSwap = true; // Fix 2: prevent re-mount auto-swap
          cartDrawer.renderContents({ sections: data.sections });
          this.patchCheckbox(true);
        }
      } finally {
        this._busy = false;
      }
    }

    setCheckoutLoading(loading) {
      var btn = document.getElementById('CartDrawer-Checkout');
      if (!btn) return;
      btn.disabled = loading;
      btn.classList.toggle('cart__checkout-button--loading', loading);
    }

    /** Fix checkbox + details state after DOM re-render (attributes may lag) */
    patchCheckbox(checked) {
      var el = document.querySelector('cart-drawer-donation');
      if (!el) return;
      var cb = el.querySelector('.cart-drawer-donation__checkbox');
      if (cb) cb.checked = checked;
      var details = el.querySelector('.cart-drawer-donation__details');
      if (details) details.classList.toggle('cart-drawer-donation__details--inactive', !checked);
      var summary = el.querySelector('.cart-drawer-donation__summary');
      if (summary) summary.style.display = checked ? '' : 'none';
    }

    /* ── Persist cart attributes ── */

    saveAttributes(isActive) {
      var attrs = {
        donation_active: isActive ? 'true' : 'false',
      };
      if (isActive) {
        attrs.donation_amount = this.donationAmount.toFixed(2);
      }

      return fetch((window.routes.cart_update_url || '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs }),
      }).catch(function () {});
    }
  }

  customElements.define('cart-drawer-donation', CartDrawerDonation);
}
